import { useSyncExternalStore } from 'react';

const subscribeToNothing = () => () => {};

/**
 * `false` during SSR and while hydrating, `true` otherwise. Use it to gate
 * output that the server cannot compute the same way as the browser (the
 * device's clock or time zone, for example), so the server-rendered HTML and
 * the hydration render agree.
 *
 * Components that mount after hydration (a dialog opened later) get `true` on
 * their first render, so there is no flash: `useSyncExternalStore` only reads
 * the server snapshot while hydrating.
 *
 * `__root.tsx` also exposes this as `data-hydrated` on `<body>`, so E2E tests
 * can wait for the app to become interactive before typing into controlled
 * inputs.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    subscribeToNothing,
    () => true,
    () => false,
  );
}
